// extracted by mini-css-extract-plugin
module.exports = {"container":"Portfolio_container__2YiLu","sidebar":"Portfolio_sidebar__C23T8","rightsection":"Portfolio_rightsection__1tBbQ"};